import React, { useContext } from "react";
import classNames from "classnames";

import { getKeyboardNumericSwitchButtonText } from "../../utils/keyboardUtils";

import { MapContext } from "../../../../Map";
import KeyboardButton from "../KeyboardButton/KeyboardButton";
import { KeyboardType } from "../../Keyboard";

import styles from "./ArSAKeyboard.module.scss";

interface Props {
  handleClick: (...args: any[]) => void;
  handleBackspace: (...args: any[]) => void;
  handleKeyboardTypeSwitch?: (type: KeyboardType) => void;
  handleSearch: () => void;
  languageSwitchButton?: React.ReactNode;
  showSearchKey?: boolean;
  searchDisabled?: boolean;
}

const ArSAKeyboard: React.FC<Props> = ({
  handleClick,
  handleBackspace,
  handleKeyboardTypeSwitch,
  handleSearch,
  languageSwitchButton,
  showSearchKey = true,
  searchDisabled = false,
}) => {
  const { controlTheme } = useContext(MapContext);

  return (
    <div className={classNames(styles.container, styles[controlTheme])}>
      <div className={styles.backdrop} />
      <div className={classNames(styles.row, styles.rowOne)}>
        <KeyboardButton type="text" text="ض" onClick={handleClick} />
        <KeyboardButton type="text" text="ص" onClick={handleClick} />
        <KeyboardButton type="text" text="ث" onClick={handleClick} />
        <KeyboardButton type="text" text="ق" onClick={handleClick} />
        <KeyboardButton type="text" text="ف" onClick={handleClick} />
        <KeyboardButton type="text" text="غ" onClick={handleClick} />
        <KeyboardButton type="text" text="ع" onClick={handleClick} />
        <KeyboardButton type="text" text="ه" onClick={handleClick} />
        <KeyboardButton type="text" text="خ" onClick={handleClick} />
        <KeyboardButton type="text" text="ح" onClick={handleClick} />
        <KeyboardButton type="text" text="ج" onClick={handleClick} />
      </div>

      <div className={classNames(styles.row, styles.rowTwo)}>
        <KeyboardButton type="text" text="ش" onClick={handleClick} />
        <KeyboardButton type="text" text="س" onClick={handleClick} />
        <KeyboardButton type="text" text="ي" onClick={handleClick} />
        <KeyboardButton type="text" text="ب" onClick={handleClick} />
        <KeyboardButton type="text" text="ل" onClick={handleClick} />
        <KeyboardButton type="text" text="ا" onClick={handleClick} />
        <KeyboardButton type="text" text="ت" onClick={handleClick} />
        <KeyboardButton type="text" text="ن" onClick={handleClick} />
        <KeyboardButton type="text" text="م" onClick={handleClick} />
        <KeyboardButton type="text" text="ك" onClick={handleClick} />
        <KeyboardButton type="text" text="ة" onClick={handleClick} />
      </div>

      <div className={classNames(styles.row, styles.rowThree)}>
        <div className={styles.rowThreeKeys}>
          <KeyboardButton type="text" text="ء" onClick={handleClick} />
          <KeyboardButton type="text" text="ظ" onClick={handleClick} />
          <KeyboardButton type="text" text="ط" onClick={handleClick} />
          <KeyboardButton type="text" text="ذ" onClick={handleClick} />
          <KeyboardButton type="text" text="د" onClick={handleClick} />
          <KeyboardButton type="text" text="ز" onClick={handleClick} />
          <KeyboardButton type="text" text="ر" onClick={handleClick} />
          <KeyboardButton type="text" text="و" onClick={handleClick} />
          <KeyboardButton type="text" text="ى" onClick={handleClick} />
        </div>
        <KeyboardButton
          dataQA="backspace"
          type="icon"
          icon="backspace"
          value=""
          onClick={handleBackspace}
          className={classNames(styles.backspaceKey, styles.rtlIcon)}
        />
      </div>
      <div className={classNames(styles.row, styles.rowFour)}>
        <div className={classNames(styles.column, styles.columnOne)}>
          <KeyboardButton
            dataQA="numeric-switch"
            type="text"
            text={getKeyboardNumericSwitchButtonText("ar-SA")}
            onClick={
              handleKeyboardTypeSwitch
                ? () => handleKeyboardTypeSwitch("numeric")
                : handleClick
            }
            className={styles.numericSwitchKey}
          />
          {languageSwitchButton && languageSwitchButton}
        </div>
        <div className={classNames(styles.column, styles.columnTwo)}>
          <KeyboardButton
            dataQA="space"
            type="text"
            text=""
            onClick={() => handleClick({ currentTarget: { name: " " } })}
            className={styles.spaceKey}
            verticalAlign={false}
          />
          <KeyboardButton
            dataQA="search"
            type="icon"
            icon="search"
            value=""
            onClick={showSearchKey ? handleSearch : () => {}}
            className={classNames(styles.searchKey, {
              [styles.searchKeyHidden]: !showSearchKey,
            })}
            disabled={!showSearchKey || searchDisabled}
          />
        </div>
      </div>
    </div>
  );
};

export default ArSAKeyboard;
